export { default as useSRP } from "./useSRP";
export { default as useSRPMultiple } from "./useSRPMultiple";
export { default as useFundCentre } from "./useFundCentre";
export { default as usePart } from "./usePart";
export { default as usePartMultiple } from "./usePartMultiple";
export { default as usePostUserData } from "./usePostUserData";
export { default as usePricesDateMetadata } from "./usePricesDateMetadata";
export { useQuery } from "@tanstack/react-query";

// TODO:
// export function useGenerateBrochure(filename: string) {
// 	const context = useSrpApiContext();
// 	if (!context) {
// 		throw new Error("SrpApiContext not found");
// 	}
// 	const { postFn } = context;
// 	return useMutation({
// 		mutationFn: async (args: PostArgs) => {
// 			const zip = await postFn(
// 				"",
// 				args.body,
// 				undefined,
// 				-1,
// 				{ ...args.headers, "Content-Type": "application/json" },
// 				process.env.BROCHURE_URI,
// 			);
// 			if (zip) {
// 				const downlink = document.createElement("a");
// 				const objURL = URL.createObjectURL(zip);
// 				downlink.href = objURL;

// 				downlink.download = `${filename}.zip`;
// 				downlink.click();
// 				setTimeout(() => {
// 					URL.revokeObjectURL(objURL);
// 				}, 1000);
// 			}
// 		},
// 	});
// }

// export function useCSRFToken(partId?: string) {
// 	const context = useSrpApiContext();
// 	if (!context) {
// 		throw new Error("SrpApiContext not found");
// 	}
// 	const { getFn } = context;
// 	return useQuery({
// 		enabled: !!partId,
// 		throwOnError: true,
// 		queryKey: [partId],
// 		queryFn: async () => {
// 			const html = await getFn(PART_API_PATH, { id: partId });
// 			const input = getElementBySelector<HTMLInputElement>(
// 				html,
// 				"input[name=csrfmiddlewaretoken]",
// 			);
// 			if (!input) throw new Error("CSRF token not found");
// 			return input.value;
// 		},
// 	});
// }

// export function useAsAtDate(partId?: string) {
// 	const context = useSrpApiContext();
// 	if (!context) {
// 		throw new Error("SrpApiContext not found");
// 	}
// 	const { getFn } = context;
// 	return useQuery({
// 		enabled: !!partId,
// 		throwOnError: true,
// 		queryKey: [partId],
// 		queryFn: async () => {
// 			const html = await getFn(PART_API_PATH, { id: partId });
// 			const input = getElementBySelector<HTMLInputElement>(
// 				html,
// 				"input[name=asAtDate]",
// 			);
// 			if (!input) throw new Error("asAtDate not found");
// 			return input.value;
// 		},
// 	});
// }

/**
 * Formats a date string to localized GB format
 *
 * @param {string} date - Date string to format
 * @returns {string} Formatted date string (e.g., "1 January 2023")
 */
// function formatDate(date: string) {
// 	return new Date(date).toLocaleDateString("en-GB", {
// 		year: "numeric",
// 		month: "long",
// 		day: "numeric",
// 	});
// }

// export function useDocuments(
// 	enabled: boolean,
// 	apiId: string,
// 	params: SrpRequestParams,
// 	fmtDate: (d: string) => string = formatDate,
// ) {
// 	const context = useSrpApiContext();
// 	if (!context) {
// 		throw new Error("SrpApiContext not found");
// 	}
// 	const { getFn, baseURL } = context;
// 	return useQuery({
// 		enabled,
// 		throwOnError: true,
// 		queryKey: [apiId, params],
// 		queryFn: async () => {
// 			const { fund_uuid, fund_id, ..._params } = params;
// 			const litJSON = await getFn(`${LIT_STRUCT_API_PATH}/${apiId}`, _params);
// 			const litStruct = LitStructureResponseSchema.parse(litJSON);
// 			const lit_types = [
// 				...litStruct.data
// 					.flatMap((d) => d.lit_types)
// 					.reduce((acc: Set<number>, number) => {
// 						acc.add(number);
// 						return acc;
// 					}, new Set<number>()),
// 			];
// 			if (lit_types.length === 0) return [];
// 			const docJSON = await getFn(DOC_API_PATH, {
// 				funds: fund_uuid ?? fund_id,
// 				lit_types: lit_types,
// 			});
// 			const docs = DocResponseSchema.parse(docJSON);
// 			return docs.data.map((d) => ({
// 				...d,
// 				date: fmtDate(d.date),
// 				url: `${baseURL}${d.url}`,
// 			}));
// 		},
// 	});
// }

// export function useGroupedDocuments(
// 	enabled: boolean,
// 	apiId: string,
// 	params: SrpRequestParams,
// 	fmtDate: (d: string) => string = formatDate,
// ) {
// 	const context = useSrpApiContext();
// 	if (!context) {
// 		throw new Error("SrpApiContext not found");
// 	}
// 	const { getFn, baseURL } = context;
// 	return useQuery({
// 		enabled,
// 		throwOnError: true,
// 		queryKey: [apiId, params],
// 		queryFn: async () => {
// 			const litWithDocs = (data: LitStructure) => data.document_count > 0;
// 			const { fund_uuid, fund_id, ..._params } = params;
// 			const litJSON = await getFn(`${LIT_STRUCT_API_PATH}/${apiId}`, {
// 				..._params,
// 				funds: fund_uuid ?? fund_id,
// 			});
// 			const litStruct = LitStructureResponseSchema.parse(litJSON);
// 			const lit_types = [
// 				...litStruct.data.filter(litWithDocs).map((d) => d.lit_types),
// 			];
// 			if (lit_types.length === 0) return [];
// 			const docsResult = await Promise.all(
// 				lit_types.map((types) =>
// 					getFn(DOC_API_PATH, {
// 						funds: fund_uuid ?? fund_id,
// 						lit_types: types,
// 					}),
// 				),
// 			);
// 			const docs = docsResult.map((json) => DocResponseSchema.parse(json));
// 			return litStruct.data.filter(litWithDocs).map((d, i) => [
// 				d,
// 				docs[i]!.data.map((d) => ({
// 					...d,
// 					date: fmtDate(d.date),
// 					url: `${baseURL}${d.url}`,
// 				})),
// 			]) as [LitStructure, Doc[]][];
// 		},
// 	});
// }
